
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as CustomPage13Fxo3lhT7Meta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/CustomPage.vue?macro=true";
import { default as DashboardPagevIRdLZfihoMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/DashboardPage.vue?macro=true";
import { default as EventCalendarPageEbAAUjLuYaMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/EventCalendarPage.vue?macro=true";
import { default as HomepageFNNlNiT9rRMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/Homepage.vue?macro=true";
import { default as MenuCollectionPageL9cgtyTvY6Meta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/MenuCollectionPage.vue?macro=true";
import { default as NotFoundPageNq0dDj2KPHMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/NotFoundPage.vue?macro=true";
import { default as PostsPageu0HDMMl1aIMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/PostsPage.vue?macro=true";
import { default as RssPageXTDoMw1BUUMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/RssPage.vue?macro=true";
import { default as SearchPageHwmq9zuGmpMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/SearchPage.vue?macro=true";
import { default as SinglePostPagebSugybh2wQMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/SinglePostPage.vue?macro=true";
import { default as SitemapPageYNmImnZ7NIMeta } from "/home/runner/work/my-mr-lite/my-mr-lite/pages/SitemapPage.vue?macro=true";
export default [
  {
    name: "CustomPage",
    path: "/CustomPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/CustomPage.vue")
  },
  {
    name: "DashboardPage",
    path: "/DashboardPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/DashboardPage.vue")
  },
  {
    name: "EventCalendarPage",
    path: "/EventCalendarPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/EventCalendarPage.vue")
  },
  {
    name: "Homepage",
    path: "/Homepage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/Homepage.vue")
  },
  {
    name: "MenuCollectionPage",
    path: "/MenuCollectionPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/MenuCollectionPage.vue")
  },
  {
    name: "NotFoundPage",
    path: "/NotFoundPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/NotFoundPage.vue")
  },
  {
    name: "PostsPage",
    path: "/PostsPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/PostsPage.vue")
  },
  {
    name: "RssPage",
    path: "/RssPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/RssPage.vue")
  },
  {
    name: "SearchPage",
    path: "/SearchPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/SearchPage.vue")
  },
  {
    name: "SinglePostPage",
    path: "/SinglePostPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/SinglePostPage.vue")
  },
  {
    name: "SitemapPage",
    path: "/SitemapPage",
    component: () => import("/home/runner/work/my-mr-lite/my-mr-lite/pages/SitemapPage.vue")
  }
]